import { StylesConfig } from 'react-select'

import { SelectValue } from 'common/components/BaseSelect'

export const autocompleteOptionCustomStyles: StylesConfig<SelectValue, false> =
  {
    option: (_, state) => {
      return {
        minHeight: 56,
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: state.isFocused ? '#f3f4f6' : '',
        '&:hover': {
          backgroundColor: '#f3f4f6',
          cursor: 'pointer',
        },
      }
    },
  }
